export default {
    computed: {
        campaignFieldsUrl() {
            return `/api/v1/contacts/${this.contactId}/campaigns/${this.campaignParamId}/fields?expand[]=options`;
        },
        campaignFields() {
            return this.$root.v2.campaignFields;
        },
        isCampaignFieldsDirty() {
            return this.campaignFields === null;
        },
    },
    methods: {
        loadCampaignFields() {
            /**
             * //TODO: come back to it when patched data is available in the response
             * if (!this.isCampaignFieldsDirty) {
             *    return Promise.resolve();
             * }
             */

            return this.$http.get(this.campaignFieldsUrl)
                .then(res => this.$root.v2.campaignFields = res.data);

        },
    },
};
